import Vue from 'vue'
import App from './App.vue'
import VueAnalytics from 'vue-analytics'
import Buefy from 'buefy'
import router from './router'
import 'buefy/dist/buefy.css'

Vue.use(Buefy);
Vue.use(VueAnalytics, {
  id: 'UA-164141905-1',
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production',
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
